// Coerce any thrown API/network error into a human-readable STRING.
//
// Why this exists: passing a non-string (a dict, a FastAPI validation list, an
// axios Error object) into `toast.error(...)` or any JSX child triggers React
// error #31 ("Objects are not valid as a React child"). Because the sonner
// <Toaster> renders near the app root, that crash can unmount the whole tree
// and white-screen the app. Several backend endpoints (e.g. the stage-
// transition gate in sales_leads.py) intentionally return a structured
// `detail` object `{ message, missing: [...] }`; this helper turns that into a
// readable, multi-line message instead of crashing.
export function apiError(err, fallback = 'Something went wrong') {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string' && d.trim()) return d;
  // FastAPI 422 validation list → join the human-readable messages.
  if (Array.isArray(d)) {
    const msgs = d.map((e) => e?.msg || e?.message).filter((m) => typeof m === 'string');
    if (msgs.length) return msgs.join('; ');
  }
  // Structured gate error: { message, missing: [...] } (stage-transition, etc.)
  if (d && typeof d === 'object') {
    const base = typeof d.message === 'string' ? d.message
      : (typeof d.msg === 'string' ? d.msg : '');
    if (Array.isArray(d.missing) && d.missing.length) {
      return `${base ? base + '\n' : ''}Missing: ${d.missing.join(' · ')}`;
    }
    if (base) return base;
    if (typeof d.error === 'string') return d.error;
  }
  // Some endpoints return { message: ... } at the top level instead of detail.
  const m = err?.response?.data?.message;
  if (typeof m === 'string' && m.trim()) return m;
  // Pure network error (no response) — axios puts a string on err.message.
  if (!err?.response && typeof err?.message === 'string' && err.message.trim()) return err.message;
  return fallback;
}
